import React, { FC } from 'react'

export const Error: FC = () => <div>Error!</div>
